const getters = {
  getInvoice: (state) => state.invoice,
  getInvoiceList: (state) => state.invoiceList,
  getInvoiceListMeta: (state) => state.invoiceListMeta,
};

export default getters;
